import { isPresent as isPresentFromLib } from 'housecall-ui/dist/common/ObjectHelper';

declare type EmptyArray = [];
declare type EmptyObject = Record<string, never>;
declare type UnknownObject = Record<string, unknown>;
declare type Empty = null | undefined | void;

/*
 * It is preferred to use dedicated checks for given variable types
 * (array.length for arrays etc.) instead of using this helper
 */
export const isPresent = <T>(object: EmptyObject | EmptyArray | UnknownObject | Empty | T): object is T =>
  isPresentFromLib(object);
